module.exports = __webpack_public_path__ + "img/45ne.30ad9d0d.svg";